'use strict';

var util = require('./util');
var Constants = require('./constants');

var currentQuery = null;
var lastQuery = null;
var runningQuery = null;
var listTotal = -1;
var listCurrent = -1;
var delay = 30;


function searchsuggest(container, defaultValue) {
    Object.assign(this, {
        $resultsContainer: null,
        /**
        * @function
        * @description Handles keyboard's arrow keys
        * @param keyCode Code of an arrow key to be handled
        */
        handleArrowKeys: function (keyCode) {
            switch (keyCode) {
                case 38:
                    // keyUp
                    listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
                    break;
                case 40:
                    // keyDown
                    listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
                    break;
                default:
                    // reset
                    listCurrent = -1;
                    return false;
            }

            this.$resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
            $('input[name="q"]').val(this.$resultsContainer.find('.selected .suggestionterm').first().text());
            return true;
        },
        /**
         * @function
         * @description trigger suggest action
         */
        suggest: function () {
            // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
            // (we had a little delay)
            if (runningQuery !== currentQuery) {
                // update running query to the most recent search phrase
                runningQuery = currentQuery;
            }

            // if it's empty clear the results box and return
            if (runningQuery.length === 0) {
                this.clearResults(true);
                runningQuery = null;
                return;
            }

            // if the current search phrase is the same as for the last suggestion call, just return
            if (lastQuery === runningQuery) {
                runningQuery = null;
                return;
            }

            // build the request url
            var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

            // execute server call
            $.get(reqUrl, function (data) {
                var suggestionHTML = data,
                    ansLength = suggestionHTML.trim().length;

                // if there are results populate the results div
                if (ansLength === 0) {
                    this.clearResults();
                } else {
                    // update the results div
                    this.$resultsContainer.html(suggestionHTML).fadeIn(200);
                }

                this.toggleOverlayContainer(true);

                // record the query that has been executed
                lastQuery = runningQuery;
                // reset currently running query
                runningQuery = null;

                // check for another required update (if current search phrase is different from just executed call)
                if (currentQuery !== lastQuery) {
                    // ... and execute immediately if search has changed while this server call was in transit
                    runningQuery = currentQuery;
                    setTimeout(this.suggest.bind(this), delay);
                }
                this.hideLeftPanel();
            }.bind(this));
        },
        /**
         * @function
         * @description
         */
        clearResults: function (ignoreOverlay) {
            if (!this.$resultsContainer) {
                return;
            }

            this.$resultsContainer.fadeOut(200, function () {
                this.$resultsContainer.empty();
                if (!ignoreOverlay) {
                    this.toggleOverlayContainer(false);
                }
            }.bind(this));
        },
        /**
         * @function
         * @description
         */
        hideLeftPanel: function () {
            //hide left panel if there is only a matching suggested custom phrase
            if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
                $('.search-suggestion-left-panel').css('display', 'none');
                $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
                $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
            }
        },

        /**
         * @function
         * @description Function appends and removes <div> overlay container to html depending on if there is any suggests
         */
        toggleOverlayContainer: function (show) {
            var $gOverlay = $('.g-overlay');

            if (show) {
                if (!$gOverlay.length) {
                    $('#wrapper').append('<div class="g-overlay"></div>');
                }

                $('html').addClass('g-noscroll-mobile');
            } else {
                if ($gOverlay.length) {
                    $gOverlay.remove();
                }

                $('html').removeClass('g-noscroll-mobile');
            }
        }
    });

    var $searchContainer = $(container);
    var $suggestionOverlay = $searchContainer.find('.suggestion-overlay');
    var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
    var $searchField = $searchForm.find('input[name="q"]');
    var $searchClear = $searchForm.find('.js-clear-search');
    var $searchCloseMobileIcon = $('.js-icon-close-search__mobile');

    $suggestionOverlay.on('click', function (e) {
        e.preventDefault();

        this.clearResults();
        $searchField.val('');
    }.bind(this));

    $searchClear.on('click', function (e) {
        e.preventDefault();

        this.clearResults();
        $searchField.val('');
    }.bind(this));

    var $stickyHeader = $(document).find(Constants.CLASS_STICKY_HEADER);
    var $html = $(document).find(Constants.CLASS_HTML);
    $searchCloseMobileIcon.on('click', function (e) {
        e.preventDefault();

        this.clearResults();
        $searchField.val('');

        $stickyHeader.removeClass('is-active-search');
        $html.removeClass('is-search-active-html');
    }.bind(this));

    // disable browser auto complete
    $searchField.attr('autocomplete', 'off');

    // on focus listener (clear default value)
    $searchField.focus(function () {
        if (!this.$resultsContainer) {
            // create results container if needed
            this.$resultsContainer = $('<div/>').attr('id', 'search-suggestions-' + container.data('search-type')).appendTo($searchContainer);
        }

        if ($searchField.val() === defaultValue) {
            $searchField.val('');
        }
    }.bind(this));

    $stickyHeader.on('showOverlay', function () {
        this.toggleOverlayContainer(true);
    }.bind(this));

    $(document).on('click', '.g-overlay', function (e) {
        if (!$searchContainer.is(e.target)) {
            this.clearResults();
            $searchField.val('');

            $stickyHeader.removeClass('is-active-search');
            $html.removeClass('is-search-active-html');
        }
    }.bind(this));

    // on key up listener
    $searchField.keyup(function (e) {

        // get keyCode (window.event is for IE)
        var keyCode = e.keyCode || window.event.keyCode;

        // check and treat up and down arrows
        if (this.handleArrowKeys(keyCode)) {
            return;
        }
        // check for an ENTER or ESC
        if (keyCode === 13 || keyCode === 27) {
            this.clearResults();
            return;
        }

        currentQuery = $searchField.val().trim();

        // no query currently running, init an update
        if (!runningQuery) {
            runningQuery = currentQuery;
            setTimeout(this.suggest.bind(this), delay);
        }
    }.bind(this));

    return this;
};

module.exports = searchsuggest;
